<div id="navbar">
  <div id="logo">
    <a routerLink=''><img src="./../../assets/favicon/android-chrome-512x512-2.png" alt="CMD"></a>
  </div>
  <div id="navbarLinks" class="nav-links">
    <a (click)="navigateTo('/media')">
      <i class="fa fa-camera-retro"></i> Media
    </a>
    <!-- <a href="#news">About</a>
    <a href="#contact">Contact</a> -->
  </div>

</div>
